module.exports = __webpack_public_path__ + "img/electrical_engineer_intro.b268f058.jpg";